import React from "react";

function Use_clean() {
  return (
    <>
      <section className="tab_contengt_holder">
        <p className="tab_text">
          Once you get your hands on this beautiful vessel, make sure to rinse
          it thoroughly, with warm water and mild soap for kitchen
          utensils/cokware, first. Take caution, and NEVER USE hot water with
          Copper vessels bare hands. You may want to rinse the vessel more than
          once. Wipe the vessel from the outside and let it dry naturally from
          inside. Please do not use any hard scrub, strong soaps, and cleaners
          with bleach. Do not put it in a dishwasher. CAUTION: Do not use your
          Copper vessel for storing anything other than drinking water. NEVER
          USE it for storing any acidic foods such as vinegar, wine, etc. A
          Copper vessel, cookware, bottle, or any other object will become
          darker in colour when exposed to air. And that really shows the purity
          of a Copper object. Exposure to air adds a verdigris colour
          (Blue-Green), also known as 'patina'. You may want to embrace the
          patinated look of your Copper vessel, which also prevents further
          exposure to Oxygen in the air. However, should you want to bring back
          the glistening and shining surface, you can polish it from the
          outside, in any of the the following ways:
        </p>

        <ul>
          <li>
            <p className="tab_text">
              Clean the outer body with a salt sprinkled on half-cut lemon{" "}
            </p>
          </li>

          <li>
            <p className="tab_text">
              Clean the outer body with a salt sprinkled on half-cut lemon{" "}
            </p>
          </li>

          <li>
            <p className="tab_text">
              Clean the outer body with a salt sprinkled on half-cut lemon{" "}
            </p>
          </li>

          <li>
            <p className="tab_text">
              Clean the outer body with a salt sprinkled on half-cut lemon{" "}
            </p>
          </li>

          <li>
            <p className="tab_text">
              Clean the outer body with a salt sprinkled on half-cut lemon{" "}
            </p>
          </li>

          <li>
            <p className="tab_text">
              Clean the outer body with a salt sprinkled on half-cut lemon{" "}
            </p>
          </li>
        </ul>

        <p className="tab_text">
          Please note that scouring or rubbing hard your Copper vessel with salt
          may result in scratches on the surface. Therefore, in the cleaning
          methods listed above using salt, please be gentle to your beautiful
          vessel while rubbing! With the methods listed above, please take
          caution of cleaning ONLY the outer surface. The inside of the vessel
          should be cleaned only clean, warm water, or with the help of a mild
          soap for kitchen utensils/cookware.
        </p>
      </section>
    </>
  );
}

export default Use_clean;
